module.exports = __webpack_public_path__ + "static/media/WhatsApp.e3846c8b.png";